module.exports = __webpack_public_path__ + "static/media/05.f724e711.png";